import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Outer width'),"suffix":_vm.value.size_unit,"outlined":"","hide-details":"auto","type":"number"},model:{value:(_vm.outerWidth),callback:function ($$v) {_vm.outerWidth=$$v},expression:"outerWidth"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }